module.exports = __webpack_public_path__ + "static/media/patient_offline.6a4b5f99.png";